const communityRoutes = [
  {
    path: ':category?',
    name: 'Blog',
    meta: {
      title: {
        en: 'Community',
        ru: 'Коммьюнити',
      },
      title_hide: true,
      hideNavigationBar: true,
    },
    component: () => import(/* webpackChunkName: 'Blog' */ '../components/pages/Blog.vue'),
  },
  {
    path: 'posts/create',
    name: 'CreateBlogPost',
    meta: {
      title: {
        en: 'Create Post',
        ru: 'Создать Пост',
      },
    },
    beforeEnter: async (to, from, next) => {
      const { requiresAuth } = await import('@martyrs/src/modules/auth/views/middlewares/auth.validation.js');
      return requiresAuth(to, from, next);
    },
    component: () => import(/* webpackChunkName: 'CreateBlogPost' */ '../components/pages/CreateBlogPost.vue'),
  },
  {
    path: 'posts/:url',
    name: 'BlogPost',
    meta: {
      title: {
        en: 'Post',
        ru: 'Пост',
      },
      title_hide: false,
    },
    component: () => import(/* webpackChunkName: 'BlogPost' */ '../components/pages/BlogPost.vue'),
  },
  {
    path: 'posts/:url/edit',
    name: 'EditBlogPost',
    meta: {
      title: {
        en: 'Edit Post',
        ru: 'Редактировать пост',
      },
    },
    beforeEnter: async (to, from, next) => {
      const { requiresAuth } = await import('@martyrs/src/modules/auth/views/middlewares/auth.validation.js');
      return requiresAuth(to, from, next);
    },
    component: () => import(/* webpackChunkName: 'CreateBlogPost' */ '../components/pages/CreateBlogPost.vue'),
  },
];

export default communityRoutes;
